import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueHtml2Canvas from 'vue-html2canvas';
 

Vue.config.productionTip = false
Vue.use(VueHtml2Canvas);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
